import { styled } from '@mui/material';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';

export const StyledDynamicIcon = styled(DynamicIcon, {
  name: 'StyledDynamicIcon',
})(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '1.4rem',
    height: '1.4rem',
  },
}));
